import React from "react";
import SEO from "../components/SEO";
import { PAGES } from "../seo/pages.config";
import AboutAreaOne from "../components/AboutAreaOne";
import FooterOne from "../components/FooterFour";
import NavBarTwo from "../components/NavbarTwo";
import TeamAreaOne from "../components/TeamAreaOne";

const About = () => {
  return (
    <>
      <SEO canonical="/about" {...PAGES["/about"]} />
      <NavBarTwo />
      <AboutAreaOne />
      <TeamAreaOne />
      <FooterOne />
    </>
  );
};

export default About;
